<template>
  <b-menu>
    <b-menu-list>
      <b-menu-item
        expanded
        :active="`/app/novo-processo` === actualRoute"
        class="not-apply"
        to="/app/novo-processo"
        tag="router-link"
        data-cy="new-process"
      >
        <template #label>
          <div class="is-flex is-align-items-flex-end pl-5">
            <b-icon
              icon="plus-circle"
              :type="isContrast ? 'is-white-dark' : 'is-green'"
            />
            {{ !isReduced ? App.MenuMain.OPEN_PROCESS : "" }}
          </div>
        </template>
      </b-menu-item>

      <template v-for="(item, index) in validMenuItemList">
        <b-menu-item
          v-if="item.path === ''"
          :key="index"
          :active="isActive"
          @click="() => handlerReduce(isActive)"
        >
          <template #label="props">
            <div class="is-flex is-align-items-flex-end pl-5">
              <b-icon :icon="item.icon" />
              {{ !isReduced ? item.label : "" }}
              <b-icon
                class="is-pulled-right ml-20"
                :icon="props.expanded ? 'chevron-up' : 'chevron-down'"
              />
            </div>
          </template>

          <template v-for="(subItem, subIndex) in item.subMenuItemList">
            <b-menu-item
              :key="subIndex"
              expanded
              :label="!isReduced ? subItem.label : ''"
              :active="item.path === actualRoute"
              :to="subItem ? subItem.path : ''"
              tag="router-link"
            />
          </template>
        </b-menu-item>

        <b-menu-item
          v-else
          :key="index"
          expanded
          :active="item.path === actualRoute"
          :to="item.path"
          tag="router-link"
          :data-cy="item.dataCY"
        >
          <template #label>
            <div class="is-flex is-align-items-flex-end pl-5">
              <b-icon :icon="item.icon" :type="item.iconColor" />
              <span>{{ !isReduced ? item.label : "" }}</span>
            </div>
          </template>
        </b-menu-item>
      </template>
      <b-menu-item
        v-if="hasAdminPermission"
        expanded
        data-cy="administration"
        @click="goToAdminMenu()"
      >
        <template #label="props">
          <div class="is-flex is-justify-content-space-between">
            <div class="is-flex is-align-items-flex-end pl-5 has-text-color-7">
              <b-icon icon="cog-outline" />
              {{ !isReduced ? General.ADMINISTRATION : "" }}
            </div>
            <b-icon
              :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              class="is-pulled-right"
              :icon="props.expanded ? 'chevron-right' : 'chevron-right'"
            />
          </div>
        </template>
      </b-menu-item>
    </b-menu-list>
  </b-menu>
</template>

<script>
import { USER_PERMISSIONS as userPermissions } from "@/utils/enumerate";
import { App, General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "MainMenu",

  props: {
    hasAdminPermission: {
      type: Boolean
    },
    isReduced: {
      type: Boolean,
      default: false
    },
    handlerReduce: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isActive: false,
      userPermissions,
      menuItemList: [
        {
          label: App.MenuMain.HOME,
          path: "/app/painel",
          icon: "tablet-dashboard",
          iconColor: "",
          dataCY: "panel"
        },
        {
          label: App.MenuMain.SIGNATURES,
          path: "/app/assinaturas",
          icon: "file-document-edit",
          iconColor: "",
          dataCY: "signatures"
        },
        {
          label: App.MenuMain.PROCESSES,
          path: "/app/processos",
          icon: "format-list-bulleted",
          iconColor: "",
          dataCY: "processes"
        },
        {
          label: App.MenuMain.DOCUMENTS_DOE,
          path: "/app/documentos-doe",
          icon: "book-arrow-right",
          iconColor: "",
          permissions: ["MANAGE_DOE", "AUTHORIZE_DOE"],
          dataCY: "document-doe"
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
      isContrast: "isContrast"
    }),
    actualRoute() {
      return this.$route.path;
    },
    validMenuItemList() {
      return this.menuItemList.filter(item =>
        !item.permissions
          ? true
          : item.permissions.find(permission =>
              this.hasPermission(userPermissions[permission])
            )
      );
    }
  },

  methods: {
    goToAdminMenu() {
      this.$emit("event-switch-menu", "ADMIN");
      this.handlerReduce(false);
    }
  }
};
</script>
